/* -----------------------------------
Copyright: Logical Developments 2025.
Project:   ConNote Portal
Filename:  Permissions.js
Author:    jdkohl
Version:   0.01
Description:
Reusable permissions management component for vendor workflows.
Handles vendor permission checkboxes for pickup and drop-in freight capabilities.
Can be used in both AddVendor and EditVendor workflows.

History:
0.01  18-12-25 JDK   Initial creation.
----------------------------------- */

function Permissions({ vendor, onChange, readOnly = false }) {
  const permissions = vendor?.permissions || { allowPickup: false, allowDropFreightIn: false };

  /**
   * Handle checkbox change for a specific permission
   * @param {string} permissionKey - The permission key to update
   * @param {boolean} value - The new value for the permission
   */
  const handlePermissionChange = (permissionKey, value) => {
    if (!readOnly && onChange) {
      const updatedPermissions = {
        ...permissions,
        [permissionKey]: value
      };
      onChange(updatedPermissions);
    }
  };

  return (
    <div className="stack">
      <div className="cluster">
        <label className="cluster">
          <input
            type="checkbox"
            checked={permissions.allowPickup || false}
            onChange={(e) => handlePermissionChange('allowPickup', e.target.checked)}
            disabled={readOnly}
          />
          Allow Pickup
        </label>
        <label className="cluster">
          <input
            type="checkbox"
            checked={permissions.allowDropFreightIn || false}
            onChange={(e) => handlePermissionChange('allowDropFreightIn', e.target.checked)}
            disabled={readOnly}
          />
          Allow Drop-In Freight
        </label>
      </div>
    </div>
  );
}

export default Permissions;
